export interface Supplier {
  name: string
  email: string
  /** Productnamen die beginnen met een van deze prefixes worden aan deze leverancier gekoppeld */
  productPrefixes: string[]
}

export const suppliers: Supplier[] = [
  {
    name: 'SEBO',
    email: 'info@sebo.nl',
    productPrefixes: ['SEBO'],
  },
]

/**
 * Vindt de leverancier voor een order op basis van de productnamen.
 * Retourneert de eerste match, of null als er geen match is.
 */
export function findSupplierForItems(itemNames: string[]): Supplier | null {
  for (const supplier of suppliers) {
    const hasMatch = itemNames.some((name) =>
      supplier.productPrefixes.some((prefix) =>
        name.toUpperCase().startsWith(prefix.toUpperCase())
      )
    )
    if (hasMatch) return supplier
  }
  return null
}
